import React from 'react';
import { Statistic as StatisticAntd } from 'antd';

const Statistic = React.memo(({ color, ...rest }) => (
  <StatisticAntd valueStyle={{ color }} precision={2} prefix="R$ " decimalSeparator="," groupSeparator="." {...rest} />
));

export default Statistic;
